import React from "react";

import { TimeExpired } from "../error-page/time-expired";

export const LoginPageExpiredPage = () => {
  return <TimeExpired title={"Срок действия страницы истек"} />;
};
